import { useEffect } from "react"
import { trpc } from "utils/trpc"

import { getToken } from "utils/storage"
import { analytics } from "utils/analytics"

export function useAuth() {
  const token = getToken()
  const auth = trpc.auth.get.useQuery(undefined, {
    enabled: !!token,
  })

  // Keep the Firebase Analytics user id in sync with the auth state.
  useEffect(() => {
    const id = auth.data?.id ?? null
    analytics.setUserId(id ? String(id) : null)
  }, [auth.data?.id])

  return auth
}
